import React, {useState,useEffect} from 'react';
import { useTranslate } from 'react-redux-multilingual'
import {CardPerso} from '@gull'
import axios from 'axios'
import apiCallCompta_correspondance from './Comp/apiCallCompta_correspondance'
import SubmitAndSelectTypeCorrespondence from './Comp/SubmitAndSelectTypeCorrespondence'

const CodeConfigurationModePay = (props) => {
    const t = useTranslate();
    const [correspondenceModePayValue,setCorrespondenceModePayValue] = useState({})
    const [disabledBtn,setDisabledBtn] = useState(false)
    const [validButton,setValidButton] = useState(false)

    useEffect(function () {
        let obj = {}

        props.allModePay.map(value=>{
            obj[value]={
                numero: (props.detailConfig && props.detailConfig.mode_paiement!=null && props.detailConfig.mode_paiement[value]) ? props.detailConfig.mode_paiement[value].numero : '',
                libelle: (props.detailConfig && props.detailConfig.mode_paiement!=null && props.detailConfig.mode_paiement[value]) ? props.detailConfig.mode_paiement[value].libelle : ''
            }
        })
        
        setCorrespondenceModePayValue(obj)
    }, [props.detailConfig])

    useEffect(function () {
        if(Object.keys(correspondenceModePayValue).length!=0){
            setDisabledBtn(false)

            Object.entries(correspondenceModePayValue).map(([modePay,value])=>{
                if(value.numero=='' || value.libelle=='') setDisabledBtn(true)
            })
        }
    }, [correspondenceModePayValue])

    const handleChange = (e,modePay,input) => {
        setCorrespondenceModePayValue({...correspondenceModePayValue,[modePay]:{...correspondenceModePayValue[modePay], [input]:e.target.value}})
    };

    const handleSubmit = () => {    
        let axiosAction = props.detailConfig ? axios.put : axios.post
        let configId = props.detailConfig ? '/'+props.detailConfig.id : ''
        let mode_paiement_obj = {}

        Object.entries(correspondenceModePayValue).map(([modePay,valueInput])=>{
            mode_paiement_obj[modePay] = {
                numero:valueInput.numero,
                libelle:valueInput.libelle
            }
        })

        let obj = {
            mode_paiement: mode_paiement_obj,
            type:props.selectType
        }
        if(props.idCompany!='company') obj["other_company"]=props.idCompany
        
        apiCallCompta_correspondance(setValidButton,axiosAction,obj,t,configId,props.setReload)
    };

    return(<>
        <SubmitAndSelectTypeCorrespondence
            disabledBtn={disabledBtn}
            validButton={validButton}
            handleSubmit={handleSubmit}
            selectType={props.selectType}
            setSelectType={props.setSelectType}

            idCompany={props.idCompany}
            config={props.config}
            setReload={props.setReload}
            company={props.company}
        />
        <div className='row'>
            {props.allModePay.map(value=>{
                return(
                    <div key={value} className="col-4">
                        <CardPerso header={t(value) ? t(value) : value}>
                            <div className="row">
                                <div className="col-6 form-group">
                                    <label>Code</label>
                                    <input 
                                        disabled={validButton}
                                        value={correspondenceModePayValue[value]?.numero || ''} 
                                        type="text" 
                                        className='form-control' 
                                        onChange={(e)=>handleChange(e,value,'numero')} 
                                    />
                                </div>
                                <div className="col-6 form-group">
                                    <label>{t('wording')}</label>
                                    <input 
                                        disabled={validButton}
                                        value={correspondenceModePayValue[value]?.libelle || ''} 
                                        type="text" 
                                        className='form-control' 
                                        onChange={(e)=>handleChange(e,value,'libelle')} 
                                    />
                                </div>
                            </div>
                        </CardPerso>
                    </div>
                )
            })}
        </div>
    </>
    )
}

export default CodeConfigurationModePay;